import React, { useEffect } from "react";
import logo from "../../assets/img/mtLogoSmall.png";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import {
  toggleScrolled,
  mobileNavToogle,
  hideMobileNavOnHashLinks,
  toggleMobileNavDropdowns,
  removePreloader,
  toggleScrollTop,
  scrollTopOnClick,
  aosInit,
  initGLightbox,
  initIsotopeLayout,
  correctScrollingPosition,
  navmenuScrollspy,
} from "../Common/main";
const Header = () => {
  useEffect(() => {
    // Add event listeners and initiate functionalities
    document.addEventListener("scroll", toggleScrolled);
    window.addEventListener("load", toggleScrolled);

    const mobileNavToggleBtn = document.querySelector(".mobile-nav-toggle");
    mobileNavToggleBtn?.addEventListener("click", mobileNavToogle);

    hideMobileNavOnHashLinks();
    toggleMobileNavDropdowns();
    removePreloader();

    window.addEventListener("scroll", toggleScrollTop);
    scrollTopOnClick();

    // window.addEventListener("load", aosInit);
    aosInit();
    initGLightbox();
    initIsotopeLayout();

    correctScrollingPosition();
    navmenuScrollspy();

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener("scroll", toggleScrolled);
      window.removeEventListener("load", toggleScrolled);
      mobileNavToggleBtn?.removeEventListener("click", mobileNavToogle);
      window.removeEventListener("scroll", toggleScrollTop);
      // window.removeEventListener("load", aosInit);
      // window.removeEventListener("load", initGLightbox);
      // window.removeEventListener("load", initIsotopeLayout);
    };
  }, []);
  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container position-relative d-flex align-items-center justify-content-between">
        <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">
          <img src={logo} alt="" />
          <h1 className="sitename">MOBITRA</h1>
          {/* <span>.</span> */}
        </a>
        {/* <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        > */}
        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <a href="/#hero" className="active">
                Home
              </a>
            </li>
            {/* <li>
              <a href="/">Vision</a>
            </li> */}
            {/* <li>
              <a href="/">Solution</a>
            </li> */}
            <li className="dropdown">
              <a href="#" onClick={(e) => e.preventDefault()}>
                <span>Solutions</span>{" "}
                <i className="bi bi-chevron-down toggle-dropdown"></i>
              </a>
              <ul>
                <li>
                  <Link to="/solutions-fleet">FleetGo</Link>
                </li>
                {/* <li className="dropdown"><a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                  <li><a href="#">Deep Dropdown 1</a></li>
                  <li><a href="#">Deep Dropdown 2</a></li>
                  <li><a href="#">Deep Dropdown 3</a></li>
                  <li><a href="#">Deep Dropdown 4</a></li>
                  <li><a href="#">Deep Dropdown 5</a></li>
                </ul>
              </li> */}
                <li>
                  <Link to="/solutions-tax">Vedum</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/about-us">About</Link>
            </li>
            <li>
              <a href="/#contact">Contact</a>
            </li>
            {/* <li><a href="index.html#services">Services</a></li>
          <li><a href="index.html#portfolio">Portfolio</a></li>
          <li><a href="index.html#pricing">Pricing</a></li>
          <li><a href="index.html#team">Team</a></li>
          <li><a href="blog.html">Blog</a></li> */}

            {/* <li>
              <a href="index.html#contact">Contact</a>
            </li> */}
            {/* <li>
              <button className="btn btn-getstarted in-list">
                Get Started
              </button>
            </li> */}
          </ul>
          <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>
        {/* <button className="btn btn-getstarted out-list">Get Started</button> */}
        {/* </div> */}
      </div>
    </header>
  );
};

export default Header;
